<template>
    <div class="risk-container">
        <div class="risk-bar">
            <div class="section red"></div>
            <div class="section yellow"></div>
            <div class="section green"></div>
        </div>
        <span class="arrow-wrap" :style="{'bottom': `${bottomValue}%`}">
            <div class="line" :style="{'background-color': `${numColor}`}"></div>
            <span class="value" :style="{'color': `${numColor}`}">{{ value }}</span>
        </span>
    </div>
</template>
  
<script>
  export default {
    name: 'RiskIndicator',
    props: {
      value: {
        type: String,
        required: true
      },
      higth: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      numColor () {
        const val = +this.value
        if (this.higth) {
          return 'red'
        }
        if (val <= 30) {
          return 'green'
        } else if (val > 30 && val <= 60) {
          return 'orange'
        } else if (val > 60) {
          return 'red'
        }
      },
      bottomValue () {
        if (this.higth) {
          return '80'
        }
        return this.value
      }
    }
  }
</script>
  
<style scoped lang="scss">

.line{
    width: 100%;
    height: 5px;
}
.value {
    line-height: 5px;
}
.arrow-wrap {
    width: 100%;
    display: flex;
    gap: 5px;
    position: absolute;
    right: 0;
    bottom: 0;
}
.risk-container {
    height: 100%;
    width: 70px;
    display: flex;
    gap: 10px;
    position: relative;
}
.risk-bar {
  display: flex;
  flex-direction: column;
  width: 30px;
  min-height: 150px;
  height: 100%;
  border: 1px solid #000;
}

.section {
  flex: 1;
}

.green {
  background-color: green;
}

.yellow {
  background-color: orange;
}

.red {
  background-color: red;
}
  </style>


// WEBPACK FOOTER //
// src/vue/app/history/index/components/AmlIndicatore.vue